
import { mapState } from 'vuex'

export default {
  methods: {
     /**
     * @desc assigns elements capable of being focused and sets focus to the first element.
     *     Adds a listener to the blur event of the last focusable element within the upsell and quickshop that
     *     sets focus back to the first focusable element in the modal, creating a loop of all
     *     focusable modal elements.
     */
      setFocusElements() {
        this.focusableElements = [
          ...this.$el.querySelectorAll(
            'input:not([type="hidden"]), a, select, button, [tabindex]:not([tabindex="-1"])',
          ),
        ].filter((el) => !el.hasAttribute('disabled'));
        if (!this.focusableElements.length) return;
        
        this.focusableElements[0].focus();
        this.focusableElements[this.focusableElements.length - 1].addEventListener('blur', this.focusLoop);
      },
      focusLoop() {
        requestAnimationFrame(() => {
          this.focusableElements[0].focus();
        });
      },
      escape(e) {
        if (e.key === 'Escape') {
          this.dismiss();
        }
      },
  }
}
